module.exports = __webpack_public_path__ + "img/Klettergerüst.ddd7d674.jpg";